import React, { Component } from "react";

import { setDepthOfPit } from "util/aws-manager";
import Button from "material-ui/Button";
import {
  getNodeVitals
} from "util/aws-manager";
import {
  CardText,
} from "reactstrap";
import FilterModal from './../filterModal/filterModal';
import SearchBox from "components/SearchBox";
import { searchDevices } from "util/aws-manager";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";
import { highlightNavigatedMenu } from "util/highlightSidebarOption";
import EnhancedTable from './EnhancedTable';

class NodeVitals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // nodeVitalsData: []
      filterData: [],
    };
  }
  componentDidMount() {
    getNodeVitals()
      .then((data) => {
        this.props.updateNodeVitalsData({ data, pageNumber: this.props.nodeVitalsData.pageNumber });
        this.props.updateNodeVitalsFilterData({ data, pageNumber: this.props.nodeVitalsData.pageNumber });
        // this.setState({
        //   nodeVitalsData: data
        // })
      })
      .catch((error) => {
        console.log('error: ', error);
      })
    this.currentPath = this.props.location.pathname;
  }

  componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.currentPath = location.pathname;
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    return (
      <div className="row configuration-page">
        <div className="col-12">
          <div className="jr-card d-sm-flex justify-content-sm-between align-items-sm-center">
            <div className="col-12 col-sm-6 col-lg-10">
              <h1 className="mb-0">Device Vitals</h1>
            </div>
            <div className="col-12 col-sm-6 col-lg-2">
              {/* Device ID: {this.props.deviceId} */}
            </div>
          </div>
        </div>
        <div className="col-12">
          <FilterModal
            filter={[]}
            data={this.state.filterData} setFilteredData={(data) => {
              this.props.updateNodeVitalsFilterData({ data, pageNumber: 0 });
            }} />
          <div className="row">
            <EnhancedTable
              passDataForFilter={(item) => {
                this.setState({
                  filterData: item,
                })
              }}
              updateDeviceId={(deviceId) => {
                this.props.updateDeviceId(deviceId);
                if (
                  !(
                    this.currentPath === "/app/components/heartbeat" ||
                    this.currentPath === "/app/components/notifications"
                  )
                ) {
                  highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
                  this.props.history.push("/app/components/heartbeat");
                }
              }} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ symbioticReducer }) => {
  return {
    deviceId: symbioticReducer.deviceId,
    nodeVitalsData: symbioticReducer.nodeVitals,
    nodeVitalFilter: symbioticReducer.nodeVitalFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDeviceId: (id) => {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateNodeVitalsData: (data) => {
      dispatch({ type: "NODE_VITALS_DATA", nodeVitals: data });
    },
    updateNodeVitalsFilterData: (data) => {
      dispatch({ type: "NODE_VITALS_FILTER_DATA", nodeVitalsFilter: data });
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(NodeVitals);



// WEBPACK FOOTER //
// ./app/routes/nodeVitals/index.js